import { PageHeader as AntdPageHeader, PageHeaderProps } from '@ant-design/pro-components';
import { Col, Row, Spin } from 'antd';
import { FC, ReactNode } from 'react';

type Props = {
  main?: ReactNode;
  loading: boolean;
} & PageHeaderProps;

const PageHeader: FC<Props> = (props: Props) => {
  const { main, children, loading = false } = props;
  return (
    <Spin spinning={loading}>
      <AntdPageHeader {...props}>
        <Row className="cbra-page-header__content">
          <Col span={24} className="content__main" style={{ paddingBottom: '10px' }}>
            {main}
          </Col>
          <Col span={24} className="content__extra">
            {children}
          </Col>
        </Row>
      </AntdPageHeader>
    </Spin>
  );
};

export default PageHeader;
